import { render } from "./OrderList.vue?vue&type=template&id=01dfde50"
const script = {}
script.render = render

export default script